/*
  Featured Tours slider
*/

export function featuredToursSlider() {
  var cellAlignValue = '';

  if (matchMedia('screen and (max-width: 767px)').matches) {
    cellAlignValue = 'center';
  } else {
    cellAlignValue = 'left';
  }

  $('.featured-tour-section.slider .featured-tours-wrp').flickity({
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    adaptiveHeight: true,
    autoPlay: true,
    cellAlign: cellAlignValue,
  });
}